const t = "_contactCardContainer_qukzr_1", n = "_body_qukzr_9", o = "_alternativeContactInfoRowContainer_qukzr_9", a = "_isWrapping_qukzr_16", e = "_detailsContainer_qukzr_21", i = "_detailRowContainer_qukzr_30", r = "_withAlternativeContactInfo_qukzr_33", C = {
  contactCardContainer: t,
  body: n,
  alternativeContactInfoRowContainer: o,
  isWrapping: a,
  detailsContainer: e,
  detailRowContainer: i,
  withAlternativeContactInfo: r
};
export {
  o as alternativeContactInfoRowContainer,
  n as body,
  t as contactCardContainer,
  C as default,
  i as detailRowContainer,
  e as detailsContainer,
  a as isWrapping,
  r as withAlternativeContactInfo
};
//# sourceMappingURL=index.es803.js.map
